import { render, staticRenderFns } from "./RVBControls.vue?vue&type=template&id=3f5f6e78"
import script from "./RVBControls.vue?vue&type=script&lang=js"
export * from "./RVBControls.vue?vue&type=script&lang=js"
import style0 from "./RVBControls.vue?vue&type=style&index=0&id=3f5f6e78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports